import Checkbox from '@jetbrains/ring-ui/components/checkbox/checkbox'
import * as React from 'react'

import styles from './QueueFilters.css'

type Props = {
  onlyMyPersonal: boolean
  setOnlyMyPersonal: (value: boolean) => unknown
}

function QueueFilters({onlyMyPersonal, setOnlyMyPersonal}: Props) {
  const onOnlyMyPersonalChange = React.useCallback(
    (event: React.SyntheticEvent<HTMLInputElement>) => {
      setOnlyMyPersonal(event.currentTarget.checked)
    },
    [setOnlyMyPersonal],
  )
  return (
    <div className={styles.queueFilters}>
      <Checkbox
        label={'Show only my personal builds'}
        containerClassName={styles.checkbox}
        checked={onlyMyPersonal}
        onChange={onOnlyMyPersonalChange}
      />
    </div>
  )
}

export default React.memo<Props>(QueueFilters)
